import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate  } from "react-router-dom";
import Cookies from "js-cookie";
import MiniDrawer from "./components/Menubar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { companyDetail } from "./store/reducers/companyDetails";
import { fetchAllUsers } from "./store/reducers/meonUserSlice";
import { companyProfile } from "./store/reducers/profileSlice";

const ProtectedLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = Cookies.get("_d_token");
  const comToken = Cookies.get("c_d_token")
  const [open, setOpen] = useState(true);
  const [openSideBar, setOpenSideBar] = useState(true);  

  useEffect(() => {
    if (token) {
      dispatch(companyDetail());
      dispatch(fetchAllUsers());
    }
  }, [token]);


  useEffect(() => {
    if (comToken && comToken!="undefined") {
      dispatch(companyProfile());
    }
  }, [comToken]);
  
  return (
    <>
      <MiniDrawer open={open} setOpen={setOpen} setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />

      <Outlet context={{ open, setOpen, openSideBar, setOpenSideBar }} />
    </>
  );
};

export default ProtectedLayout;
